<template>
    <div>
        <public-title>房态日历
            <!-- <div slot="right" class="ml-auto" v-if="storeInfo.type != 99">
                <span class="text-link ml-5 h6 mr-1" v-show="isGroup" @click="$router.back()">返回列表</span>
            </div> -->
        </public-title>
        <div class="activ">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="activeName">
                <el-tab-pane label="全部" name="0"></el-tab-pane>
                <el-tab-pane label="余量" name="1"></el-tab-pane>
                <el-tab-pane label="订房" name="2"></el-tab-pane>
                <el-tab-pane label="" name="3">
                    <label slot="label" class="pointer">待接团队
                    <span class="unread-msg  red" v-if="IndexData.order_arr.confirm_doing_self_handle > 0">{{IndexData.order_arr.confirm_doing_self_handle}}</span>
                    </label>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="load-area" v-if="activeName<3">
            <div>
                <div class="text-left mb-3">
                    <span >当前日期：</span>
                    <el-select v-model="roomType" placeholder="请选择" size="small"  >
                        <el-option v-for="item in monthTimestamps" :key="item.id" :label="item.title" :value="item.id" />
                    </el-select>
                    <!--供应商只能看，不能设置-->
                    <div class="smallsq" v-if="userLoginMessage.level!=2">
                        <el-button slot="right" class="titke-bttom " @click="publishConfirm" type="primary" size="mini" icon="el-icon-tickets">发确认单</el-button>
                        <el-button  class="" @click="centerDialogVisible=true;changetime=''" type="primary" size="small">修改余量</el-button>
                    </div>
                </div>
                <template>
                    <div class="roomalender">
                        <div  v-for="item in weekDays" class=" leite" :class="{'weekend':item === '星期六' || item === '星期日'}" :key="item">{{item}}</div>
                    </div>
                    <div class="roomalender lender ">
                        <div class=" calender grey" v-for="(item,index) in week-1" :key="index"></div>
                        <!--全部模式-->
                        <div class=" calender" v-for="(item,index) in Monthtiem" :key="item.select_time" v-if="activeName == 0">
                            <div class="fudtitle">{{item.title}}</div>
                            <div class="tiem"><p @click="TeamList(item)" :class="{'cursor_pointer calenders':item.team_num>0}">{{item.team_num||0}}</p><span>预订团数 </span></div>
                            <div class="name">
                                <p>房</p>
                                <p>余</p>
                                <p>订</p>
                            </div>
                            <div class="Internal">
                                <div>
                                    <span>单</span>
                                    <span class="greyColor " :class="{'redColor':item.s_num1>0,'cursor_pointer':timeday/1000<item.select_time}" @click="modifyaddRoom(item)">{{item.s_num1||0}}间</span>
                                    <span class="greyColor" :class="{'shqColor':item.b_num1>0}">{{item.b_num1||0}}间</span>
                                </div>
                                <div>
                                    <span>双</span>
                                    <span class="greyColor " :class="{'redColor':item.s_num2>0,'cursor_pointer':timeday/1000<item.select_time}" @click="modifyaddRoom(item)">{{item.s_num2||0}}间</span>
                                    <span class="greyColor" :class="{'shqColor':item.b_num2>0}">{{item.b_num2||0}}间</span>
                                </div>
                            </div>
                        </div>
                        <!--单独一项-->
                        <template v-for="item in Monthtiem">
                            <div class=" calender"  :key="item.select_time" v-if="activeName != 0">
                                    <!-- <div class="fudtitle">{{item.title}}</div> -->
                                <div class="tiem form-item"><p>{{item.title}}</p><span>日 </span></div>
                                <div class="form-label">
                                    <div class="form-team_num"><p @click="TeamList(item)" :class="{'cursor_pointer calenders':item.team_num>0}">{{item.team_num||0}}</p><span>预订团数 </span></div>
                                    <div class="form-name" v-if="activeName == 1">
                                        <div  @click="modifyaddRoom(item)"><i>单</i><p :class="{'redColor':item.s_num1>0,'cursor_pointer':timeday/1000<item.select_time}">{{item.s_num1||0}}</p></div>
                                        <div  @click="modifyaddRoom(item)"><i>双</i><p :class="{'redColor':item.s_num2>0,'cursor_pointer':timeday/1000<item.select_time}">{{item.s_num2||0}}</p></div>
                                    </div>
                                    <div class="form-name" v-if="activeName == 2">
                                        <div  @click="modifyaddRoom(item)"><i>单</i><p :class="{'shqColor':item.b_num1>0}">{{item.b_num1||0}}</p></div>
                                        <div  @click="modifyaddRoom(item)"><i>双</i><p :class="{'shqColor':item.b_num2>0}">{{item.b_num2||0}}</p></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="text-left mt-4">
                        <div class="yfe">
                            <el-button class="but" @click="selectTiem('minus')" type="primary" size="small" v-if="roomType!='0'" >上一月</el-button>
                            <el-button class="but" @click="selectTiem('add')" type="primary" size="small" v-if="roomType!=monthTimestamps.length">下一月</el-button>
                        </div>
                    </div>
                </template>
            </div>
            <el-dialog
                title="修改余量"
                :visible.sync="centerDialogVisible"
                :close-on-click-modal="false"
                width="460px"
                top="34vh"
                center>
                <AddRoom @switchsoto="switchsoto" :changetime="changetime" v-if="centerDialogVisible" :store_id="store_id" ></AddRoom>
            </el-dialog>
            <el-dialog
                title="预订团"
                :visible.sync="cliquenumber"
                :close-on-click-modal="false"
                width="1200px"
                center>
                <TeamList :select_time="select_time" :store_id="store_id" v-if="cliquenumber"></TeamList>
            </el-dialog>    
        </div>
        <template v-if="activeName==3">
            <IndexHandle :activeName="activeName"></IndexHandle>
        </template>
    </div>
</template>
<script>
import {mapGetters,mapActions,mapState,mapMutations} from 'vuex'
import IndexHandle from '@/views/Order/OrderLists/IndexHandle'
import AddRoom from './AddRoom.vue'
import TeamList from './TeamList.vue'
export default {
    name: 'RoomCalendar',
    components:{ AddRoom,TeamList,IndexHandle},
    data() {
        return {
            centerDialogVisible:false,
            weekDays:['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
            calender:[],
            monthTimestamps:[],                                                             //月份列表
            roomType:'3',                                                                   //当前月份
            Monthtiem:[],                                                                   //月份日期列表
            changetime:{},                                                                  //修改余量时间
            week:0,                                                                         //当月第一天星期几
            cycleTiem:[],                                                                   //当月31天日期
            timeday:0,                                                                      //当天时间戳
            cliquenumber:false,                                                              //预订团展示
            select_time:'',                                                                   //点击时间戳
            activeName: '0'
        }
    },
    computed: {
      ...mapState(['StoreRoomArr','StoreCalendar','userLoginMessage','IndexData']),
      ...mapGetters(['userInfo','storeInfo','isGroup']),
      //路由中的酒店ID，存在时判断为集团酒店获取日历
      store_id() { return this.$route.query.store||this.storeInfo.storeId},
    },
    created() {
      //获取房间列表
      this.getMonthTimestamps();
    },
    watch: {
        roomType(){
            this.timeMonth();
        }
    },
    methods: {
        ...mapMutations(['UPDATECONFIRMINFO',]),
        ...mapActions(['getStoreCalendar','HotelsRoomCalendarList']),
              //发布确认单
    publishConfirm(){
      this.UPDATECONFIRMINFO(this.storeInfo.storeId)
      let query = {orderConfirm:true,modify:true,orderConfirmSend:true}
      this.$router.push({name:'OrderPost',query})
    },
    /*添加房型*/
      goAddRoom() {
        let query = {step:'3',storeId:this.$route.query.storeId,GST:this.$route.query.GST}
        this.$router.replace({name:'RoomMeetManage',query})
      },
        getMonthTimestamps() {
            const timestamps = [];
            let roomType=[];
             // 复制当前日期，避免修改原始日期
            const currentDate = new Date();
            for(let i = 3; i >=1; i--){
                const targetDate = new Date(currentDate);
                // 设置月份，自动处理跨年情况
                targetDate.setMonth(currentDate.getMonth() - i);
                console.log(targetDate);
                // 设置为当月第一天
                targetDate.setDate(1);
                // 设置时间为00:00:00
                targetDate.setHours(0, 0, 0, 0);
                // 获取时间戳（毫秒）
                timestamps.push(targetDate.getTime());
            }
            // 获取当前月份和往后6个月的时间戳
            for (let i = 0; i < 6; i++) {
                const targetDate = new Date(currentDate);
                // 设置月份，自动处理跨年情况
                targetDate.setMonth(currentDate.getMonth() + i);
                // 设置为当月第一天
                targetDate.setDate(1);
                // 设置时间为00:00:00
                targetDate.setHours(0, 0, 0, 0);
                // 获取时间戳（毫秒）
                timestamps.push(targetDate.getTime());
            }
            for(let i in timestamps){
                roomType.push({id:i,title:this.formatDate(timestamps[i]),tiem:timestamps[i]/1000})
            }
            this.monthTimestamps = roomType;
            this.timeMonth();
        },
        //时间戳转日期
        formatDate(timestamp,i=0) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            // 获取月份并补零
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const sun = String(date.getDate());
            if(i==0){
                return `${year}年${month}月`;
            }if(i==1){
                return `${sun}`;
            }
        },
        //循环当月每天0点时间戳
        timeMonth(){
            let roomType=this.monthTimestamps[this.roomType*1],Monthtiem=[];
            console.log(roomType);
            //传月份时间戳判断当月有多少天
            let date = new Date(roomType.tiem*1000);
            const year = date.getFullYear();
            const month = date.getMonth();
            let n= new Date(year, month + 1, 0).getDate();
            //循环当月每天0点时间戳生成月份日期
            for(let i=1;i<=n;i++){
                let time=new Date(year, month, i, 0, 0, 0, 0).getTime();
                Monthtiem.push({select_time:time/1000,title:this.formatDate(time,1)})
            }
            this.cycleTiem=Monthtiem;
            this.PsotHotelsRoomCalendarList();
        },
        //获取房态列表（默认传当月时间戳）
        async PsotHotelsRoomCalendarList(){
            let roomType=this.monthTimestamps[this.roomType*1];
            let Monthtiem=this.cycleTiem;
            let date = new Date(roomType.tiem*1000);
            //n为天数
            const week=date.getDay();
            let data={
                store_id:this.store_id,
                month_time:roomType.tiem
            }
            console.log(week);
            this.week=week==0?7:week;
            //获取当天时间戳
            const currentDate = new Date();
            // 设置时间为00:00:00
            currentDate.setHours(0, 0, 0, 0);
            // 获取时间戳（毫秒）
            this.timeday=currentDate.getTime();
            this.HotelsRoomCalendarList({
                data,
                successFun:(res)=>{
                    console.log(res);
                    Monthtiem.forEach((item,index)=>{
                        res.forEach(room=>{
                            if(room.select_time==item.select_time){
                                Monthtiem[index]={
                                    ...item,
                                    ...room,
                                }
                            }
                        })
                    })
                    this.calender=res;
                    this.Monthtiem=[...Monthtiem];
                    console.log( this.Monthtiem); 
                }
            });

        },
        //点击一项修改房态
        modifyaddRoom(item){
            if(this.timeday/1000<=item.select_time){
                this.centerDialogVisible=true;
                this.changetime=item;
            }
        },
        switchsoto(){
            this.centerDialogVisible=false;
            this.PsotHotelsRoomCalendarList()
        },
        selectTiem(e){
            let roomType
            if(e=='add'){
                roomType=this.roomType*1+1;
            }else{
                roomType=this.roomType*1-1;
            }
            this.roomType=roomType.toString();
        },
        //开启预订团
        TeamList(item){
            if(item.team_num>0){
            this.cliquenumber=true;
            this.select_time=item.select_time;
            }
        },
        //切换显示模式
        handleClick(tab, event){
            console.log(tab, event);
        },
    }
}
</script>
<style lang="scss" scoped>
    .load-area{
        border: 1px #E4E7ED solid;
        margin-top: -1px;
        border-radius: 0 6px 6px 6px;
    }
    .shqColor{
        color: #fb983a !important;
        font-weight: bold;
    }
    .greyColor{
        color: #999;
    }
    .calenders{
        color: var(--smtc-color-primary) !important;
        font-weight: bold;
    }
  .cursor_pointer{
    cursor: pointer;
  }
  .roomalender{
    display: flex;
    justify-content: left;
    border-collapse: collapse;
    width: 100%;
    border-left: 1px #999 solid;
    .leite{
        width: 14.2%;
         height: 40px;
        background-color: var(--smtc-color-primary);
        color: #fff;
        line-height: 40px;
        border-right: 1px #eee solid;  
    }
    .weekend{
        background: #fdb900;
    }
    .calender{
        border-right: 1px #999 solid;
        padding: 20px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        .tiem{
            font-size: 20px;
            float: left;
            width: 36%;
            height: 105px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            position: relative;
            z-index: 3;
            >p{
                font-size: 28px;
                text-align: center;
                font-family: '黑体';
                color: #999;
            }
            >span{
                font-size: 12px;
     
                margin-top: 6px;
            }
        }
        .name{

            line-height: 35px;
            margin-right: 10px;
            position: relative;
            z-index: 9;
        }
        .Internal{
            float: right;
            width: 52%;
            border-left: 1px #999 solid;
            display: flex;
            position: relative;
            z-index: 3;
            div{
                width: 50%;
            }
            span{
                width: 100%;
                text-align: center;
                display: block;
                float: left;
                line-height: 35px;
            }
        } 
    }
  }
    .lender{
        flex-wrap:wrap;
        justify-content:left;
        .calender{
            width: 14.2% !important;
            border-bottom: 1px var(--smtc-color-primary) solid;
        }
    }
    .yfe{
        width: 100%;
        display: flex;
        justify-content: center;
        
    }
    .smallsq{
        float: right;
        margin-right: 10px;
    }
    .grey{
        background-color: #f5f5f5;
    }
    .currently{
        width: 69%;
        float: left;
        background-color: #f5f5f5;
        height: 160px;
        text-align: center;
        line-height: 156px;

        position: absolute;
        top: 1px;
        right: 1px;
        z-index: 1;
    }

    .redColor{
        color: #333;
        font-weight: bold;
    }
    .fudtitle{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        color: #eee;
        height: 100%;
        font-size: 80px;
        font-weight: bold;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .but{
        width: 160px;
    }
    .activeName  {
        background-color: #fff;
        float: left;
    }
    .activ{
        overflow: hidden;
    }
    .form-label{
        width: 65%;
        border-left: 1px #eee solid;
    }
    .roomalender .calender .form-item p{
        font-size: 28px;
        font-weight: bold;
        font-family: '黑体';
    }
    .form-team_num{
            width: 94%;
            margin: 0 auto;
            margin-bottom: 6px;
        p{
            font-size: 24px;

            color: #999;
        }
        span{
            color: #999;
            font-size: 14px;
        }
    }
    .form-name{
        width: 60%;
        margin: 0 auto;
        div{
            width: 90%;
            margin: 0 auto;
            padding: 4px 0;
            display: flex;
            justify-content: space-between;
            i{
                color: #999;
                font-style: normal;
            }
            p{
                font-size: 16px;
                color:#999;
                font-family: '黑体';
            }
            span{
                font-size: 12px;
                font-weight: normal;
                color: #999;
            }
            .redColor{
                color: var(--smtc-color-primary); 
                font-weight: bold;
            }
            .shqColor{
                color: #fb983a !important;
                font-weight: bold;
            }
        }
        div:nth-child(1){
            border-bottom: 1px #eee solid;
        }
    }
</style>
